import { render, staticRenderFns } from "./StudyResultDetailImageList.vue?vue&type=template&id=4c215f8a&scoped=true&lang=pug"
import script from "./StudyResultDetailImageList.vue?vue&type=script&lang=ts"
export * from "./StudyResultDetailImageList.vue?vue&type=script&lang=ts"
import style0 from "./StudyResultDetailImageList.vue?vue&type=style&index=0&id=4c215f8a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c215f8a",
  null
  
)

export default component.exports